import * as React from 'react';
import * as I18n from 'i18n-js';
import track from 'react-tracking';
import { experiments } from '../constants';
import { isExperimentEnabled } from '../user_context_helpers';
import {
  withUserContext,
  IUserContext,
} from './user_context_provider';
import { formatExperimentsForEventAttributes } from '../elog/mparticle';
import { MParticleEventName } from '../elog/mparticle_tracker';
import { core_apimessages_Money as Money } from '../rql';
import { TrackingProps, VIEW } from '../tracker';

import PriceDisplay from './price_display';

const COMPONENT_NAME = 'CombinedShippingPriceCallout';

interface IExternalProps {
  combinedShippingRate: Money;
  trackCombinedRateView?: boolean;
  listingId: string;
}

type IProps = IExternalProps & IUserContext & TrackingProps;

export function CombinedShippingPriceCallout(props: IProps) {
  const showFree = props.combinedShippingRate.amountCents === 0;

  React.useEffect(() => {
    if (props.trackCombinedRateView) {
      props.tracking.trackEvent({
        eventType: VIEW,
        mParticleView: {
          componentName: COMPONENT_NAME,
          eventName: MParticleEventName.ViewedI2CombinedShipping,
          listingId: props.listingId,
          combinedRateFree: showFree,
          experiments: formatExperimentsForEventAttributes(props.user, [
            experiments.I2_COMBINED_SHIPPING_CALLOUT,
          ]),
        },
      });
    }
  }, []);
  // passing a 2nd arg of an empty array tracks the event only once on mount

  if (!isExperimentEnabled(props.user, experiments.I2_COMBINED_SHIPPING_CALLOUT)) {
    return null;
  }

  return (
    <>
      <PriceDisplay
        amountCents={props.combinedShippingRate.amountCents}
        currency={props.combinedShippingRate.currency}
        display={props.combinedShippingRate.display}
        showFree={showFree}
      />
      {` ${I18n.t('commons.whenYouCombineShipping')}`}
    </>
  );
}

export default track(
  { componentName: COMPONENT_NAME },
)(withUserContext<IProps>(CombinedShippingPriceCallout));



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/combined_shipping_price_callout.tsx